import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../../context/notificationContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useDueDateTypesApi } from "../../../http/dueDateTypes/api";
import { UpsertDueDateType } from "../../../http/dueDateTypes/types";
import SvgAdd from "../../icons/Add";
import Button from "../../ui/Button";
import ModalDialog from "../../ui/ModalDialog";
import DueDateTypeForm, { DueDateTypeFormBody } from "./DueDateTypeForm";

const CreateDueDateTypeButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dueDateTypesApi = useDueDateTypesApi();

  const onSubmit = async (data: DueDateTypeFormBody) => {
    const body: UpsertDueDateType = {
      name: data.name,
    };

    setIsSubmitting(true);
    try {
      await dueDateTypesApi.insertAdminDueDateType(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.dueDateTypes.new}>
          <DueDateTypeForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateDueDateTypeButton;
